// @flow
import React, { type Element } from 'react';
import { Panel } from 'angieslist-react-components';
import { Track } from 'angieslist-app-platform';
import { get } from 'lodash';
import { Link } from 'react-router';
import type { MetricCategory } from '../../../types';
import './categoryList.scss';

type Props = {
  categories?: MetricCategory[],
  categoryId?: number,
  serviceProviderId?: string | number,
};

const CategoryListComponent = ({
  categories,
  categoryId,
  serviceProviderId,
}: Props): Element<"div"> => (
  <div>
    <Panel id="reviewTab--category-panel" header={<strong>CATEGORIES</strong>}>
      <ul id="reviewTab--category-list" className="list-unstyled">
        {
          (categories || []).map((category, index) => {
            const activeLink = category.id === categoryId || (category.id === 0 && !categoryId);
            return (
              <li key={category.id} className="reviewTab--category-list-item">
                <Track>
                  <Link
                    id={`reviewTab-category-list-link-${category.id}`}
                    to={`/app/store/${String(serviceProviderId)}/reviews?categoryId=${category.id}`}
                    className={activeLink ? 'reviewTab--active-category-link' : ''}
                    data-track-categoryid={category.id}
                  >
                    <span className="reviewTab-category-list-item-name">
                      {get(category, 'name', '')} ({get(category, 'displayReviewCount', '')})
                    </span>
                    <i className="icon icon-right-open" />
                  </Link>
                </Track>
              </li>
            );
          })
        }
      </ul>
    </Panel>
  </div>
);

export default CategoryListComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/CategoryList.js